// src/utils/formHelpers.js
// Shared utilities used across multiple form components.

/**
 * Maps ISO 2-letter country codes to human-readable country names.
 */
export const countryMap = {
  NG: 'Nigeria',
  GH: 'Ghana',
  KE: 'Kenya',
  UG: 'Uganda',
  CI: "Cote d'Ivoire",
  SN: 'Senegal',
  ZA: 'South Africa',
  MA: 'Morocco',
  EG: 'Egypt',
  US: 'USA',
};

/**
 * Extracts submitter identity fields from a staff profile object.
 *
 * @param {object} profile - Staff profile (from safeLocalStorageGet)
 * @returns {{ submittedBy: string, creatorName: string }}
 */
export function getSubmitterInfo(profile) {
  const submittedBy = profile?.primaryEmail || profile?.email || 'unknown';
  const creatorName =
    profile?.firstname
      ? `${profile.firstname} ${profile.lastname || ''}`.trim()
      : profile?.name || 'unknown';

  return { submittedBy, creatorName };
}

/**
 * Resolves the default country name from a profile's country code.
 *
 * @param {object} profile - Staff profile
 * @returns {string} Full country name or the raw code/empty string
 */
export function getDefaultCountry(profile) {
  const code = profile?.country || '';
  const upperCode = code.toUpperCase();
  return countryMap[upperCode] || code;
}
